module.exports = __webpack_public_path__ + "img/logo-brand.420db063.svg";